// extracted by mini-css-extract-plugin
export default {"main":"createPayment_main__byVAz","form":"createPayment_form__xYVCg","button":"createPayment_button__nIf49"};